<div class="flex flex-col h-full gap-4">
  @let opkraevningsListe =
    opkraevningsListerService.selectedOpkraevningsListe();
  @if (opkraevningsListe) {
    <p-panel>
      <div class="flex gap-20">
        <div>
          <table>
            <tr>
              <td class="font-semibold" style="width: 150px">Kørsel nummer</td>
              <td>{{ opkraevningsListe.koerselsNr }}</td>
            </tr>
            <tr>
              <td class="font-semibold">Afsendt</td>
              <td>
                {{ opkraevningsListe.afsendt | date: 'dd-MM-yyyy HH:mm' }}
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Regnr</td>
              <td>{{ opkraevningsListe.pengeinstitut.regnr }}</td>
            </tr>
          </table>
        </div>
        @let summary = opkraevningsListerService.summary();
        <div>
          <table>
            <tr>
              <td class="font-semibold" style="width: 200px">
                Godkendte opkrævninger
              </td>
              <td class="numbers" style="width: 100px">
                {{ summary?.antalGodkendte | number: '1.0' }} stk.
              </td>
              <td class="numbers">
                {{ summary?.sumGodkendte | number: '1.2' }} kr.
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Opkrævninger i alt</td>
              <td class="numbers">
                {{ summary?.antalOpkraevninger | number: '1.0' }} stk.
              </td>
              <td class="numbers">
                {{ summary?.sumTotal | number: '1.2' }} kr.
              </td>
            </tr>
          </table>
        </div>
        @if (!afsendt()) {
          <div class="flex gap-4">
            <p-button
              label="Godkend alle"
              icon="pi pi-check"
              (onClick)="onClickGodkendAlle()"></p-button>
            <p-button
              label="Afsend kørsel"
              icon="pi pi-send"
              (onClick)="onClickAfsend()"></p-button>
          </div>
        }
        <div>
          <p-button
            icon="pi pi-file-excel"
            label="Hent regneark"
            outlined
            (click)="onClickExport(opkraevningsListe.id)"></p-button>
        </div>
      </div>
    </p-panel>
    <div class="flex-1 overflow-hidden">
      <app-opkraevning-grid [opkraevningsListeId]="opkraevningsListe.id" />
    </div>
  }
</div>
<p-confirm-dialog />
<p-dialog
  header="Godkend alle opkrævninger"
  [modal]="true"
  [visible]="showGodkendAlleSummary()"
  [style]="{ width: '25rem' }">
  <table>
    <tr>
      <td class="numbers text-right pr-2">
        {{ godkendAlleSummary()?.antalOpkraevninger || 0 | number: '1.0' }}
      </td>
      <td>opkrævninger behandlet</td>
    </tr>
    <tr>
      <td class="numbers text-right pr-2">
        {{ godkendAlleSummary()?.alleredeGodkendt || 0 | number: '1.0' }}
      </td>
      <td>var allerede godkendt</td>
    </tr>
    <tr>
      <td class="numbers text-right pr-2">
        {{ godkendAlleSummary()?.forkertStatus || 0 | number: '1.0' }}
      </td>
      <td>har forkert status</td>
    </tr>
    <tr>
      <td class="numbers text-right pr-2">
        {{ godkendAlleSummary()?.manglerKonto || 0 | number: '1.0' }}
      </td>
      <td>mangler debiteringskonto</td>
    </tr>
    <tr>
      <td class="numbers text-right pr-2">
        {{ godkendAlleSummary()?.manglerReference || 0 | number: '1.0' }}
      </td>
      <td>mangler indbetalings ID</td>
    </tr>
    <tr>
      <td class="numbers text-right pr-2 font-bold">
        {{ godkendAlleSummary()?.antalGodkendte || 0 | number: '1.0' }}
      </td>
      <td class="font-bold">blev godkendt</td>
    </tr>
  </table>
  <div class="flex justify-end gap-2">
    <p-button label="Ok" (click)="closeGodkendAlleSummary()" />
  </div>
</p-dialog>
